export default __webpack_public_path__ + "static/will-581fd73cad87318bc45f2bbf84111479.png";